import { USER_GET_LOADED } from '@uncinc/react-drupal-core/dist/redux/actions/Entity/User';
import { DEFAULT_LANGUAGE } from '../../config/constants';
import { setLanguage } from '../actions/UI';

const userMiddleware = ({ dispatch, getState }) => (next) => (action) => {
  switch (action.type) {
    case USER_GET_LOADED: {
      const userPreferredLanguage = action.data.preferred_langcode?.[0]?.value || DEFAULT_LANGUAGE;
      const currentLanguage = getState().getIn(['ui', 'language'], DEFAULT_LANGUAGE);

      if (userPreferredLanguage !== currentLanguage) {
        dispatch(setLanguage(userPreferredLanguage));
      }

      break;
    }

    default:
      break;
  }

  return next(action);
};

export default userMiddleware;
